<template>
	<div>
		<div v-if="success && sfa" class="mt-2 mb-4">
			<div class="mb-3">
				<h6><b>Uložené.</b></h6>
				Pokyn bol úspešne zaevidovaný pre klienta.
			</div>
		</div>
		<div v-else-if="success" class="mt-2 mb-4">
			<div v-if="request.transactionType === 'withdrawal'">
				<div class="mb-3">
					<h6><b>Vážený klient,</b></h6>
					pokyn na výber peňažných prostriedkov bol úspešne zaevidovaný.
				</div>
			</div>
			<div v-else>
				<div class="mb-3">
					<h6><b>Vážený klient,</b></h6>
					peniaze prosím pošlite nasledovne:
				</div>
				<table>
					<tr>
						<td>Suma:</td>
						<td>
							<b>{{ request.value }} EUR</b>
						</td>
					</tr>
					<tr>
						<td>Číslo účtu (IBAN):</td>
						<td><b>SK30 0900 0000 0051 6751 5092</b></td>
					</tr>
					<tr>
						<td>Banka:</td>
						<td><b>Slovenská sporiteľňa a.s.</b></td>
					</tr>
					<tr>
						<td class="pr-4">Variabilný symbol:</td>
						<td>
							<b>{{ personalInfo.birthnumber }}</b>
						</td>
					</tr>
					<!--        <tr>-->
					<!--          <td class="pr-2">Špecifický symbol:</td>-->
					<!--          <td>-->
					<!--            <b>{{ request.strategy }}</b>-->
					<!--          </td>-->
					<!--        </tr>-->
				</table>
			</div>
		</div>
		<div v-else-if="status === 1" class="mt-2 mb-4">
			<div v-if="request.transactionType === 'withdrawal'">
				<div>
					<form
							class="request-wrapper"
							@submit.prevent="forceDepositOrWithdrawal()"
					>
						<div class="mb-3">
							<h6><b>Vážený klient,</b></h6>
							na Vašom portfóliu {{ this.request.strategyName }} nie je dostatok
							peňažných prostriedkov v mene EUR. Na realizáciu Vášho pokynu bude
							potrebné vykonať konverziu z inej meny alebo odpredať časť Vášho
							portfólia – {{ this.request.strategyName }}. Aj napriek tomu
							chcete zadať pokyn na výber peňažných prostriedkov?
						</div>
						<div class="text-center mt-4">
							<button type="submit" class="btn btn-warning w-50">
								Áno
							</button>
							<a class="btn btn-outline-warning w-50" @click="status = 0">
								Nie
							</a>
						</div>
					</form>
				</div>
			</div>
		</div>
		<div v-else-if="status === 2">
			<div v-if="request.transactionType === 'withdrawal'">
				<div class="mb-3">
					<h6><b>Vážený klient,</b></h6>
					na Vašom portfóliu {{ this.request.strategyName }} nie je dostatok
					peňažných prostriedkov a cenných papierov na realizáciu Vášho pokynu.
					Prosím upravte sumu peňažných prostriedkov na výber.
				</div>
				<div class="text-center mt-4">
					<button
							type="submit"
							class="btn btn-warning w-50"
							@click="status = 0"
					>
						Upraviť sumu
					</button>
					<button
							class="btn btn-outline-warning w-50"
							@click="$parent.$parent.hide"
					>
						Nie
					</button>
				</div>
			</div>
		</div>
		<form
				v-else
				class="request-wrapper"
				@submit.prevent="depositOrWithdrawal()"
		>
			<div class="row">
				<div class="col-12">
					<div class="row">
						<b-form-group>
							<b-form-radio-group
									v-model="request.transactionType"
									:options="options"
									buttons
									button-variant="outline-warning"
									class="w-100"
									name="radio-btn-outline"
							></b-form-radio-group>
						</b-form-group>
					</div>
					<div class="row">
						<div class="col-4">Investičná stratégia:</div>
						<select
								class="col-8 form-control"
								v-model="request.strategy"
								required
						>
							<option :value="null">Vyberte investičnú stratégiu</option>
							<option
									v-for="(strategy, i) in request.transactionType === 'withdrawal'
                  ? withdrawalStrategies
                  : depositStrategies"
									:value="strategy.id"
									:key="i"
							>{{ strategy.name }}
							</option>
						</select>
					</div>
					<div class="row">
						<div class="col-4">Suma (EUR):</div>
						<input
								class="col-8 form-control"
								type="text"
								v-model="request.value"
								required
						/>
					</div>
					<div class="text-center mt-4">
						<button type="submit" class="btn btn-warning w-50">
							<font-awesome-icon
									v-if="loading"
									icon="spinner"
									class="ml-2"
									spin
							/>
							Odoslať
						</button>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: "TradeForm",
	computed: {
		depositStrategies() {
			return this.$store.state.instructions.availableStrategies;
		},
		withdrawalStrategies() {
			return this.$store.state.instructions.withdrawalStrategies;
		},
		personalInfo() {
			return this.$store.state.account.profileInfo;
		},
		assignedToMe() {
			return this.$store.state.account.assignedToMe;
		},
		sfaInstruction() {
			return this.$store.state.instructions.sfaInstruction;
		}
	},
	methods: {
		depositOrWithdrawal() {
			this.loading = true;
			const strategies =
					this.request.transactionType === "withdrawal"
							? this.withdrawalStrategies
							: this.depositStrategies;

			// this.request.strategyName = strategies.filter(item => {
			// 	return item.id === this.request.strategy;
			// })[0].name;
			
			for(let i in strategies) {
				if(strategies[i].id === this.request.strategy) {
					this.request.strategyName = strategies[i].name;
					break;
				}
			}

			let requestName = "instructions/depositOrWithdrawal";

			if (this.assignedToMe.length > 0) {
				requestName = "instructions/depositOrWithdrawalSFA";
				this.sfa = true;
			}

			this.request.force = false;

			this.$store
				.dispatch(requestName, this.request)
				.then(() => {
					this.success = true;
					this.loading = false;

					if(this.$store.state.messages.item)
						this.$store.dispatch("messages/messageDetail", {
							id: this.request.predefinedMessage
						});	
				})
				.catch(error => {
					this.status = error.response.data.result.accountStatus;
					this.loading = false;
				});
		},
		forceDepositOrWithdrawal() {
			this.loading = true;
			const strategies =
					this.request.transactionType === "withdrawal"
							? this.withdrawalStrategies
							: this.depositStrategies;

      this.request.strategyName = Object.fromEntries(Object.entries(strategies).filter(item => {
        return item[1].id === this.request.strategy;
      }))[0].name;

			this.request.force = true;

			this.$store
					.dispatch("instructions/depositOrWithdrawal", this.request)
					.then(() => {
						this.success = true;
						this.loading = false;
					})
					.catch(() => {
						this.request.force = false;
						this.loading = false;
					});
		}
	},
	mounted() {
		if(this.sfaInstruction) {
			this.request = {...this.sfaInstruction};
			if(this.$store.state.messages.item)
				this.request.predefinedMessage = this.$store.state.messages.item.id;
			this.$store.commit('instructions/setSfaInstruction', {});
		}
	},
	data() {
		return {
			request: {
				transactionType: this.requestInfo.isWithdrawal
						? "withdrawal"
						: "deposit",
				currency: 1,
				force: false
			},
			options: [
				{text: "VKLAD", value: "deposit"},
				{text: "VÝBER", value: "withdrawal"}
			],
			success: false,
			sfa: false,
			status: 0,
			loading: false
		};
	},
	props: {
		requestInfo: {
			type: Object,
			default: function () {
				return {
					isWithdrawal: true
				};
			}
		}
	}
};
</script>
